import { DEFAULT_S3_URI } from "../../shared/Config";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ImgBackground = () => {

    const urlPath = useParams()
    const urlTenant = (urlPath.tenant ? urlPath.tenant : 'mobilemed')
    const [imgFundo, setImgFundo] = useState(`${DEFAULT_S3_URI}${urlTenant}/fundo.webp`)

    const fetchImage = async () => {
        const r = await fetch(imgFundo)
        if (!r?.ok) {
            setImgFundo(`${DEFAULT_S3_URI}mobilemed/fundo.webp`)
        }
    };

    useEffect(() => {
        fetchImage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <img src={imgFundo} alt="" className={`img-fluid`} style={{ maxHeight: 1000, borderRadius: 10 }} loading="lazy" />
        </>
    );
};

export default ImgBackground;
